import { storageGetItem, StorageUserInfoKey } from '@/utils/auth'
const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  userInfo: (state) => {
    return state.user.userInfo || JSON.parse(storageGetItem(StorageUserInfoKey))
  },
  taskTypeOptions: (state) => state.robot.taskTypeOptions, //任务类型
  actionTimeOptions: (state) => state.robot.actionTimeOptions, //任务执行时间点
}
export default getters
